<sc-flex vertical fitHeight stretchContent class="no-field-space">
  <sc-dialog-title>
    <sc-dictionary-label
      dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.picture-series-title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <sc-scroll-pane>
        <sc-picture-scanner [deviceSettings]="selectedConfiguration" (selectionChanged)="handleSelection($event)"
          *ngIf="selectedConfiguration != null"></sc-picture-scanner>
      </sc-scroll-pane>
    </sc-padding>
  </sc-flex-fitting-content>
  <div>
    <sc-padding>
      <sc-flex>
        <form [formGroup]="selectConfigurationForm" style="width: 280px;">
          <sc-select-field formControlName="model" [data]="options"
            labelDictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.picture-series-model"></sc-select-field>
        </form>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-cancel-button (click)="cancel()"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-confirm-button (click)="confirm()"
          [disabled]="currentSelection == null || currentSelection.length === 0"></sc-confirm-button>
      </sc-flex>
    </sc-padding>
  </div>
</sc-flex>
